import React, { forwardRef, useEffect } from 'react'
import MaterialTable from 'material-table'
import SearchIcon from '@material-ui/icons/Search'
import Clear from '@material-ui/icons/Clear'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import ChevronRight from '@material-ui/icons/ChevronRight'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ArrowUpward from '@material-ui/icons/ArrowUpward'

export default function MaterialTableDemo({ data }) {
  const [state, setState] = React.useState([])

  useEffect(() => {
    const formatData = data.map(item => {
      const partido = item[2]
      const candidato = item[3]
      const delito = item[4]
      const fallo = item[5]
      const ano = item[6]
      const foto = item[7]
      const logo = item[8]
      const numero = item[9]
      return { partido, candidato, delito, fallo, ano, foto, logo, numero }
    })
    setState(formatData)
  }, [data])

  return (
    <div style={{ maxWidth: '100%' }}>
      <MaterialTable
        Icons={{ Clear }}
        components={{
          Container: props => <div>{props.children}</div>
          //Container: React.Fragment
        }}
        columns={[
          {
            field: 'logo',
            Title: 'Partido',
            render: rowData => rowData.logo ? <img src={rowData.logo} alt="partido" style={{width: 35, borderRadius: '50%', marginTop: 5, marginRight: 5}}/> : null
          },
          { title: 'Partido', field: 'partido' },
          {
            field: 'foto',
            Title: 'Avatar',
            render: rowData => rowData.foto ? <img src={rowData.foto} alt="candidato" style={{width: 35, borderRadius: '50%', marginTop: 5, marginRight: 5}}/> : null
          },
          { title: 'Candidato', field: 'candidato' },
          { title: 'Número', field: 'numero' },
          { title: 'Delito', field: 'delito' },
          {
            title: 'Fallo penal',
            field: 'fallo'
          },
          { title: 'Año', field: 'ano' }
        ]}
        data={state}
        title=""
        localization={{
          toolbar: {
            searchTooltip: 'Buscar',
            searchPlaceholder: 'Buscar'
          },
          pagination: {
            labelRowsSelect: 'resultados',
            labelDisplayedRows: '{from}-{to} de {count}'
          }
        }}
        options={{
          headerStyle: {
            padding: 4,
            fontWeight: 'bolder',
            fontSize: 13,
            lineHeight: 1.1
          },
          cellStyle: {
            padding: 4,
            fontSize: 13
          },
          pageSize: 10
        }}
        icons={{
          Search: forwardRef((props, ref) => (
            <SearchIcon {...props} ref={ref} />
          )),
          ResetSearch: forwardRef((props, ref) => (
            <Clear {...props} ref={ref} />
          )),
          FirstPage: forwardRef((props, ref) => (
            <FirstPage {...props} ref={ref} />
          )),
          LastPage: forwardRef((props, ref) => (
            <LastPage {...props} ref={ref} />
          )),
          NextPage: forwardRef((props, ref) => (
            <ChevronRight {...props} ref={ref} />
          )),
          PreviousPage: forwardRef((props, ref) => (
            <ChevronLeft {...props} ref={ref} />
          )),
          SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />)
        }}
      />
    </div>
  )
}
